export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6914.49f72e48.jpg";